import {Errors, KAError, type ErrorWithResponse} from "@khan/logging";

/**
 * Check the status of a response and throw an error if it is not 2xx or 304.
 *
 * Since `fetch` by default doesn't fail when the status is a non-2xx status,
 * we add a check to every request's promise chain that fails it when these
 * errors occur.
 *
 * @param request The request that was made.
 * @param response The response.
 * @returns The response if the status is 2xx or 304.
 * @throws An error if the status is not 2xx or 304.
 */
export const throwOnBadStatus = (
    request: Request,
    response: Response,
): Response => {
    // Code taken from
    // https://github.com/github/fetch/blob/master/README.md#handling-http-error-statuses
    if (
        (response.status >= 200 && response.status < 300) ||
        response.status === 304
    ) {
        return response;
    }
    const error: ErrorWithResponse = new KAError(
        `${request.url}: ${response.statusText ?? ""} ${response.url ?? ""}`,
        Errors.Internal,
    ) as ErrorWithResponse;
    error.response = response;
    throw error;
};
